module.exports = __webpack_public_path__ + "img/logo_25.7ccfcaec.png";